<rt-dialog-header [heading]="heading">
  @if (containerDataSnapshot.subheading) {
    <div class="subheading">
      {{ containerDataSnapshot.subheading }}
    </div>
  }
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  <rt-form-field [hasLabelMargin]="false">
    <rt-label>{{ 'app.wysiwyg.dialog.text_to_display' | translate }}</rt-label>
    <div class="input-hint">
      {{ 'app.wysiwyg.dialog.text_to_display_hint' | translate }}
    </div>
    <rt-input
      variant="rounded"
      [formControl]="$any(form.get('label'))"
      (keydown.enter)="submit()"
      [placeholder]="placeholder"
    ></rt-input>
  </rt-form-field>

  @if (containerDataSnapshot.type === gdprConsentLinkType && !isDelayedEdit) {
    <div margin-top>
      <rt-form-field>
        <rt-label>{{ 'app.wysiwyg.dialog.expiration' | translate }}</rt-label>
        <div layout-horizontal layout-centered-y>
          <rt-input
            variant="rounded"
            [formControl]="$any(form.get('period'))"
            [maxWidth]="'190px'"
            type="number"
            (keydown.enter)="submit()"
            margin-right-small-x
          >
          </rt-input>
          {{ 'app.gdpr.days' | translate }}
        </div>
      </rt-form-field>
    </div>
  }
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  @if (!containerDataSnapshot.isEdit && isValidLink) {
    <rt-button (click)="linkOut()" variant="outline" class="optional">
      <rt-icon name="open-in-new"></rt-icon>
      <span>{{ 'app.common.preview' | translate }}</span>
    </rt-button>
  }
  @if (containerDataSnapshot.isEdit) {
    <rt-button (click)="removeLink()" variant="outline" class="optional danger-on-hover">
      <rt-icon name="remove-circle"></rt-icon>
      <span>{{ 'app.wysiwyg.dialog.remove_link' | translate }}</span>
    </rt-button>
  }

  @if (!loading) {
    <rt-button variant="plain" (click)="dialog.close()">
      {{ 'app.common.cancel' | translate }}
    </rt-button>
  }
  <rt-button variant="primary" [disabled]="form.invalid" (click)="submit()">
    {{
      (containerDataSnapshot.isEdit
        ? 'app.common.save'
        : 'app.redactor_inserts.gdpr.dialog.insert_link'
      ) | translate
    }}
  </rt-button>
</rt-dialog-footer>
